import * as React from "react";
import { useMutation } from "@grandvisionhq/graphql";
import { useCartStorage } from "@grandvisionhq/lib-utils-cart";
import { isNil } from "@grandvisionhq/utils";
import { REMOVE_CART_LINE_ITEMS } from "../../operations/mutations/operations/mutations/remove-cart-line-items.js";
const useRemoveInsuranceFromCart = (onSuccess) => {
  const [{ cartId }, { setCartCount }] = useCartStorage();
  const [removeCartItems, removeCartLineItemsMutation] = useMutation(REMOVE_CART_LINE_ITEMS, {
    onCompleted: (response) => {
      if ("removeCartLineItems" in response) {
        const { success, cart } = response.removeCartLineItems;
        success && cart && setCartCount(cart.numberOfItems);
      }
      onSuccess && onSuccess();
    }
  });
  const removeFromCart = React.useCallback(
    (lineItemId) => {
      if (isNil(cartId)) {
        console.error("No cart ID available");
        return;
      }
      removeCartItems({
        variables: {
          cartInput: {
            cartId,
            lineItems: [
              {
                id: lineItemId
              }
            ]
          }
        }
      });
    },
    [cartId, removeCartItems]
  );
  const { called, loading, error } = removeCartLineItemsMutation;
  return [removeFromCart, { called, loading, error }];
};
export {
  useRemoveInsuranceFromCart
};
//# sourceMappingURL=use-remove-insurance-from-cart.js.map
